import PropTypes from 'prop-types';
import * as ICONS from './icons'
import { NODE_TYPES } from '../Node/config';
import './style.css';

const NodeTypeIcon = props => {
    return ICONS[ props.type.toUpperCase() ]({ ...props });
}

NodeTypeIcon.propTypes = {
    type: PropTypes.oneOf([ ...NODE_TYPES, 'meatball', 'chain' ]).isRequired
}

NodeTypeIcon.defaultProps = {
    type: NODE_TYPES[ 0 ]
}

export default NodeTypeIcon;